import styled, {css} from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 45rem;
  height:80vh;
  max-height:80vh;
  margin-top: 0.5rem;
  font-size: 1.2rem;
  gap: 1rem;
  background-color: #f8f9fa;
  padding: 0 0.5em 0.2rem;
  cursor: auto;
  overflow: scroll;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
  .filter--{
    display:flex;
    width:100%;
    justify-content: center;
    align-items: center;
    background-color: #1D86FF;
    gap: 1rem;
    color: #ffffff;
    padding: 0.5rem;
    border-radius: 4px;
    .date{
      width: 11rem;
    }
    .icon--{
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.5rem;
      background-color: #ffffff;
      border-radius: 50%;
      color: #000000;
      cursor: pointer;
      &:hover{
        background-color: #f6f6f6;
      }
    }
  }
` 
export const Card = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 6rem;
  max-height: 8rem;
  border-radius: 6px;
  background-color: #ffffff;
  box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);
  border-left: 5px solid #1D86FF;
` 
export const Note = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 1rem;
  padding: 1px 0.5em 1px;
  overflow: auto;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
`
export const Info = styled.div`
  display: flex;
  justify-content: start;
  margin-left: 0.5rem;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
`
export const Tag = styled.span`
  margin-right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding:5px;
  border-radius: 3px;
  height: 16px;
  font-size: 11px;
  line-height: 16px;
  color: #54656f;
  background-color: #d0d0d0;
  border: 1px solid #d0d0d0;
  margin-top: 0.3rem;

  ${(props) =>
    props.type === 'note' &&
    css`
      &{
        color: #000;
        background-color: #f6b610;
        border: 1px solid #f6b610;
      }
    `}
  ${(props) =>
    props.type === 'in call' &&
    css`
      &{
        color: #fff;
        background-color: #ff5252;
        border: 1px solid #ff5252;
      }
    `}
  ${(props) =>
    props.type === 'invite' &&
    css`
      &{
        color: #fff;
        background-color: #00a884;
        border: 1px solid #00a884;
      }
    `}  
  ${(props) =>
    props.type === 'inFo' &&
    css`
      &{
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.3rem;
        max-width: 210px;
        color: black;
        background-color:#1D86FF3b;
        border:0px;
        border-radius:3px;
        border-left: 3px solid #1D86FF;
        font-size: 1rem;
        box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);

        span{
          height: 100%;
          display: flex;
          font-size: 1rem;
          justify-content: center;
          align-items: center;
        }


        p{
          max-width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

      }
    `}      
    ${(props) =>
    props.type === 'name' &&
    css`
      &{
        display: flex;
        justify-content: left;
        align-items: center;
        gap: 0.3rem;
        max-width: 180px;
        color: black;
        background-color:#1D86FF3b;
        border:0px;
        border-radius:3px;
        border-left: 3px solid #1D86FF;
        font-size: 1rem;
        box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);

        span{
          height: 100%;
          display: flex;
          font-size: 1rem;
          justify-content: center;
          align-items: center;
        }


        p{
          max-width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

      }
    `}
`